import React, { useRef } from 'react';
import { Link } from 'react-router-dom';
import vid from '../../resources/video.mp4';

const Hero = () => {
  const video = useRef();
  return (
    <div className='hero_bg'>
      <video autoPlay muted loop src={vid} className='hero_video'>
        <source src={vid} />
      </video>
      <div className='w-100'>
        <div className='container-fluid position-relative heading_container py-3'>
          <div className='d-flex justify-content-center align-items-center flex-column'>
            <div style={{ maxWidth: `700px` }}>
              <h1 className='display-4 font-weight-bold text-center'>
                Trade With Data <br />
                Not With Emotion
              </h1>
              <p className='h4 text-center font-weight-normal'>
                Follow Wall Street's smart money to your next profitable investment with 
                unusual option activity data and report
              </p>
            </div>
          </div>
        </div>
        <div className='text-center position-relative mt-5'>
          <Link
            to='/database'
            className='btn btn-primary rounded-pill py-3 px-5'
          >
            <h3 className='mb-0'>Get Started</h3>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Hero;
